import lzDicTxt from '@/components/commons/lzDicTxt';
import { filterTime } from '@/api/filter';
const dic = JSON.parse(localStorage.dic);

const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const POLICY_STATUS = dic['POLICY_STATUS']
const SUPPLIERS = dic['SUPPLIERS']
const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
export default {
  components: {
    lzDicTxt
  },
  data() {
    return {
      // 转介人结算列表
      ledgerDownList: [],
      ledgerDownSelectedArr: [],
      // 周边收支列表
      extsvcItemList: [],
      extsvcItemSelectedArr: [],
      // 财务增减列表
      financeItemList: [],
      financeItemSelectedArr: [],
      // 列表类型 ledgerDown-转介人结算列表，extsvcItem-周边收支列表，financeItem-财务增减列表
      tableType: 'ledgerDown',
      // 选中列表
      selectArr: [],
      mode: 'read' // add | edit | read
    };
  },
  computed: {
    columns() {
      let columns = [];
      if (this.tableType === 'ledgerDown') {
        // 转介人结算
        columns.push(
          {
            title: '保单编号',
            key: 'policyNo',
            align: 'center',
            minWidth: 140
          },
          {
            title: '转介人',
            key: 'tenantName',
            align: 'center',
            width: 140
          })

        if (userInfo.merchantType == 3) {
          columns.push(

            {
              title: '转介人级别',
              key: 'level',
              align: 'center',
              width: 140,
              render(h, params) {
                let level = params.row.level;
                return <span>{chineseNumbers[level]}级</span>;
              }
            }
          )
        }
        columns.push(
          {
            title: '保单期数',
            key: 'policyTerm',
            align: 'center',
            width: 100
          },
          {
            title: '结算次数',
            key: 'currCount',
            align: 'center',
            width: 100
          },
          {
            title: '产品名称',
            key: 'productName',
            align: 'center',
            minWidth: 200
          },
          {
            title: '供应商',
            key: 'suppliers',
            align: 'center',
            width: 100,
            render(h, params) {
              let suppliers = params.row.suppliers;
              return <span>{SUPPLIERS[suppliers]}</span>;
            }
          },
          {
            title: '保险公司',
            key: 'companyName',
            align: 'center',
            minWidth: 200
          },
          {
            title: '年缴保费',
            slot: 'fee',
            align: 'center',
            minWidth: 200
          },
          {
            title: '保单状态',
            key: 'policyStatus',
            align: 'center',
            minWidth: 120,
            render(h, params) {
              let policyStatus = params.row.policyStatus;
              return <span>{POLICY_STATUS[policyStatus]}</span>;
            }
          },
          {
            title: '生效日期',
            align: 'center',
            width: 120,
            render(h, params) {
              let effectDate = params.row.effectDate;
              return <span>{filterTime(effectDate, 'YYYY-MM-DD')}</span>;
            }
          },
          {
            title: '冷静期截止日',
            align: 'center',
            width: 140,
            render(h, params) {
              let expirationDate = params.row.expirationDate;
              return <span>{filterTime(expirationDate, 'YYYY-MM-DD')}</span>;
            }
          },
          {
            title: '保单积分比',
            key: 'commissionRate',
            align: 'center',
            render(h, params) {
              if (params.row.commissionRate) {
                return <span>{params.row.commissionRate + '%'}</span>;
              } else {
                return '';
              }
            },
            width: 120
          },
          {
            title: '结算汇率',
            key: 'settleRate',
            align: 'center',
            width: 100
          },
          {
            title: '结算积分',
            key: 'settlementAmount',
            align: 'center',
            minWidth: 150
          }
        )
      } else if (this.tableType === 'extsvcItem') {
        // 周边收支
        columns = [
          { title: '保单编号', key: 'policyNo', align: 'center' },
          { title: '结算积分', key: 'amount', align: 'center' },
          {
            title: '类型',
            key: 'type',
            align: 'center',
            render(h, params) {
              if (params.row.type === 1 || params.row.type === '1') {
                return <span>支出</span>;
              } else if (params.row.type === 2 || params.row.type === '2') {
                return <span>收入</span>;
              } else {
                return '';
              }
            }
          },
          {
            title: '收支类目',
            key: 'cate',
            align: 'center',
            render(h, params) {
              return <lzDicTxt dicCode={params.row.cate} dicType="EXTSVC_CATE" />;
            }
          }
        ];
      } else if (this.tableType === 'financeItem') {
        // 财务增减
        columns = [
          {
            title: '保单编号',
            key: 'policyNo',
            align: 'center'
          },
          { title: '结算积分', key: 'amount', align: 'center' },
          {
            title: '类型',
            key: 'type',
            align: 'center',
            render(h, params) {
              if (params.row.type === 1 || params.row.type === '1') {
                return <span>支出</span>;
              } else if (params.row.type === 2 || params.row.type === '2') {
                return <span>收入</span>;
              } else {
                return <span></span>;
              }
            }
          }
        ];
      }
      return columns;
    }
  },
  methods: {
    getTabLabel(label, value) {
      let count = 0;
      // if (this.total !== undefined) {
      //   if (value === this.tableType) {
      //     return `${label}(${this.total})`;
      //   }
      // } else {
      if (value === 'ledgerDown') {
        count = this.ledgerDownList.length;
      } else if (value === 'extsvcItem') {
        count = this.extsvcItemList.length;
      } else if (value === 'financeItem') {
        count = this.financeItemList.length;
      }
      // }

      return `${label}(${count})`;
    },
    updateSelectArr() {
      // 列表类型 ledgerDown-转介人结算列表，extsvcItem-周边收支列表，financeItem-财务增减列表
      if (this.tableType === 'ledgerDown') {
        this.ledgerDownSelectedArr = JSON.parse(JSON.stringify(this.selectArr));
      } else if (this.tableType === 'extsvcItem') {
        this.extsvcItemSelectedArr = JSON.parse(JSON.stringify(this.selectArr));
      } else if (this.tableType === 'financeItem') {
        this.financeItemSelectedArr = JSON.parse(JSON.stringify(this.selectArr));
      }
    },
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this._searchAllParams = JSON.parse(JSON.stringify(this.searchParams));
      this.tableData = tableData;
      this.selectArr = [];
      this.updateSelectArr();
    },
    // 列表选中
    onSelect(arr) {
      arr.forEach(item => {
        this.selectPush(item);
      });
    },
    // 列表单个取消选中
    onSelectCancel(arr, row) {
      this.selectDel(row);
    },
    // 列表全选取消
    onSelectAllCancel() {
      this.tableData.forEach(item => {
        this.selectDel(item);
      });
    },
    // 去掉选择数据
    selectDel(data) {
      this.selectArr.forEach((item, idx) => {
        if (item.id == data.id) {
          this.selectArr.splice(idx, 1);
        }
      });
      this.updateSelectArr();
    },
    // 添加选择数据
    selectPush(data) {
      let has = false;
      this.selectArr.forEach(item => {
        if (item.id == data.id) {
          has = true;
        }
      });
      if (!has) {
        this.selectArr.push(data);
      }
      this.updateSelectArr();
    }
  }
};
